class e extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
export {
  e as AccessDenied
};
